import React from 'react'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import HorariosData from '../../Components/Admin/HorariosData/HorariosData'

export default function Horarios() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <HorariosData />
                </div>
            </section>
        </div>
    )
}
